import { gql } from 'graphql-tag';

export const ADDRESS_POSTCODE_SUGGESTION_QUERY = gql`
    query getAddressPostcodeSuggestion($addressPartial: String!) {
        getSuggestedAddresses(address: $addressPartial) {
            suggestions: g {
                address: v
                urlPath: i
            }
            previousSuggestions: p {
                address: v
            }
        }
    }
`;
